module.exports = __webpack_public_path__ + "static/media/WhitePapiPacify.0c4b471a.jpg";